module.exports = __webpack_public_path__ + "static/media/icon-user.64ef23f6.svg";